import { Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import { AuthserviceService } from '../@core/services/authservice.service';
import { LoginResponse } from '../@core/models/users';
import { NgxSpinnerService } from 'ngx-spinner';



@Component({
    selector: 'app-sidenav',
    templateUrl: './sidenav.component.html',
    styleUrls: ['./sidenav.component.css'],
    standalone: false
})


export class SidenavComponent {

  mobileMenuOpen = false;
  isMobile = window.innerWidth < 640;
  @ViewChild('menuToggle') menuToggle?: ElementRef<HTMLButtonElement>;

  @HostListener('window:resize')
  onResize(): void {
    this.isMobile = window.innerWidth < 640;
    if (!this.isMobile) this.mobileMenuOpen = false;
  }

  @HostListener('document:keydown.escape')
  closeMobileMenu(): void {
    if (!this.mobileMenuOpen) return;
    this.mobileMenuOpen = false;
    this.menuToggle?.nativeElement.focus();
  }

  closeOnNavigation(event: MouseEvent): void {
    if ((event.target as HTMLElement).closest('a')) this.closeMobileMenu();
  }

  openSections = {
    administracion: true,
    minerva: false,
    automatismos: false,
    automatismosOld: false,
    comunicaciones: false,
    debug: false,
    otros: false,
    conexiones: true,
  };

  toggleSection(section: keyof typeof this.openSections) {
    this.openSections[section] = !this.openSections[section];
  }

  isSectionOpen(section: keyof typeof this.openSections): boolean {
    return this.openSections[section];
  }

  User: LoginResponse | undefined;
  get hasInternalAccess(): boolean {
    return (this.User?.roles ?? []).some(role => role === 'admin' || role === 'technician' || role === 'api');
  }
  readonly spinnerName = 'sidenavSpinner';
  constructor(
    private authservice : AuthserviceService ,
    private spinner: NgxSpinnerService
    ) {
    this.User = this.authservice.usuarioValue;
      }


  logout(){
    this.spinner.show(this.spinnerName);
    this.authservice.logout();
    setTimeout(() => this.spinner.hide(this.spinnerName), 1500);
  }

}
